<template>
  <div>
    <div class="header pb-8 pt-lg-8 d-flex align-items-center profile-header">
      <b-container fluid>
        <span class="mask bg-gradient-success opacity-8"></span>
      </b-container>
    </div>
    <b-container fluid class="mt--7">
      <b-card>
        <b-form>
          <div>
            <b-row>
              <b-col>
                <b-card no-body>
                  <el-table
                    class="table-responsive table"
                    header-row-class-name="thead-light"
                    :data="datosUsuarios"
                  >
                    <el-table-column
                      sortable
                      label="ID"
                      prop="name"
                      min-width="90px"
                    >
                      <template v-slot="{ row }">
                        <b-media no-body class="align-items-center">
                          <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">
                              {{ row.id }}
                            </span>
                          </b-media-body>
                        </b-media>
                      </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      label="Nombre y Apellidos"
                      min-width="200px"
                    >
                      <template v-slot="{ row }">
                        <b-media no-body class="align-items-center">
                          <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">{{
                              row.name
                            }}</span>
                          </b-media-body>
                        </b-media>
                      </template>
                    </el-table-column>
                    <el-table-column sortable label="Correo" min-width="160px">
                      <template v-slot="{ row }">
                        <b-media no-body class="align-items-center">
                          <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">{{
                              row.email
                            }}</span>
                          </b-media-body>
                        </b-media>
                      </template>
                    </el-table-column>
                    <el-table-column
                      sortable
                      label="Privilegios"
                      min-width="170px"
                    >
                      <template v-slot="{ row }">
                        <b-media no-body class="align-items-center">
                          <b-media-body>
                            <span class="font-weight-600 name mb-0 text-sm">{{
                              row.privilegios
                            }}</span>
                          </b-media-body>
                        </b-media>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Editar"
                      min-width="150px"
                      prop="date"
                    >
                      <template v-slot="{ row }">
                        <b-row>
                          <b-col
                            ><el-button
                              type="primary"
                              icon="el-icon-edit"
                              circle
                              @click="editarUsuario(row)"
                            ></el-button
                          ></b-col>
                          <b-col
                            ><el-button
                              type="primary"
                              icon="el-icon-delete"
                              circle
                              @click="eliminarCatequista(row.id)"
                            ></el-button
                          ></b-col>
                        </b-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-container>
    <modal-usuarios
      idModal="modalUsuario"
      :usuario="usuario"
      @guardaUsuario="guardaUsuario"
    ></modal-usuarios>
  </div>
</template>
<script>
import axios from '@/directives/axios.js';
import ModalUsuarios from "@/components/modals/ModalUsuarios.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();
export default {
  name: "register",
  components: {
    ModalUsuarios,
  },
  data() {
    return {
      usuario: undefined,
      datosUsuarios: [],
      superUsuario: null,
      optionsCurso: undefined,
      cursoSelected: null,
      selecion: [],
      nombre: "",
      email: "",
      password: "",
    };
  },
  created() {
    axios({
      method: "GET",
      url: `/usuarios/todosUsuarios`,
      withCredentials: true,
    })
      .then((data) => {
        this.datosUsuarios = data.data.usuarios;
      })
      .catch((erro) => {
        swal.fire({
          title: `Error`,
          text: "Ocurrio un error inesperado, intentelo mas tarde",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning",
          icon: "warning",
        });
      });
  },
  watch: {},
  methods: {
    editarUsuario(usuario) {
      this.usuario = usuario;
      this.$nextTick(() => {
        this.$bvModal.show("modalUsuario");
      });
    },
    guardaUsuario(usuario) {
      loader.open();
      axios({
        method: "POST",
        url: `/register`,
        withCredentials: true,
        data: usuario,
      })
        .then((data) => {
          this.datosUsuarios = data.data.usuarios;
          loader.close();
          swal.fire({
            title: `Datos Guardados Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
  },
};
</script>
<style></style>
